module.exports = __webpack_public_path__ + "img/ck-entry-banner.fd6575b8.png";